export const SumationHourAndLeavingRequest = (users) => {
  // console.log("hfsdaklf : ",users)
  const times = SumationHour(users);
  const timeLeaving = SumationLeavingRequestHour(users);

  let hours = times?.split("h")[0];
  let minutes = times?.split("h")[1];
  let hoursLeaving = timeLeaving?.split("h")[0];
  let minutesLeaving = timeLeaving?.split("h")[1];

  return `${parseInt(hours) + parseInt(hoursLeaving)}h ${
    parseInt(minutes) + parseInt(minutesLeaving)
  }m`;
  // console.log()
};

export const SumationLeavingRequestHour = (users) => {
  let totalMinutes = 0;
  users?.map((atten) => {
    console.log(atten);
  });
  users?.forEach((atten) => {
    const extraHour = atten?.leave_request;
    if (extraHour) {
      const [hours, minutes] = extraHour.split(":");
      const hoursInMinutes = parseInt(hours, 10) * 60;
      totalMinutes += hoursInMinutes + parseInt(minutes, 10);
    }
  });
  const totalHours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;

  return `${totalHours}h ${remainingMinutes}m`;
};

export const SumationHour = (users) => {
  let totalDifference = 0;
  // console.log(users)
  users?.forEach((atten) => {
    const startDate = new Date(atten?.approve_checkin);
    const endDate = new Date(atten?.approve_checkout);
    const diffMs = endDate - startDate;
    if (!isNaN(diffMs)) {
      totalDifference += diffMs;
    }
  });

  // Convert totalDifference to hours and minutes if needed
  const totalHours = Math.floor(totalDifference / (1000 * 60 * 60));
  const totalMinutes = Math.floor((totalDifference / (1000 * 60)) % 60);

  return `${totalHours}h ${totalMinutes}m`;
};

export const SumationExtraHour = (users) => {
  let totalMinutes = 0;

  users?.forEach((atten) => {
    const extraHour = atten?.extra_hour;
    if (extraHour) {
      const [hours, minutes] = extraHour.split(":");
      const hoursInMinutes = parseInt(hours, 10) * 60;
      totalMinutes += hoursInMinutes + parseInt(minutes, 10);
    }
  });
  const totalHours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;

  return `${totalHours}h ${remainingMinutes}m`;
};

export const TotalDailyWage = (users, attendances) => {
  // const [totalTimeDifference, setTotalTimeDifference] = useState(0);
  // const [totalDailyWage, setTotalDailyWage] = useState(0);

  let totalDifference = 0;
  attendances?.forEach((atten) => {
    const startDate = new Date(atten?.approve_checkin);
    const endDate = new Date(atten?.approve_checkout);

    if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
      const diffMs = endDate - startDate;
      totalDifference += diffMs;
    }
  });
  const totalHours = totalDifference / (1000 * 60 * 60);
  console.log(totalHours);
  const totalDailyWage = totalHours * users?.user_info?.hourly_wage;

  return totalDailyWage;
};

export const formatNumberWithCommas = (number) => {
  if (typeof number === "number") {
    return number.toLocaleString();
  } else if (typeof number === "string") {
    return parseFloat(number).toLocaleString();
  }
  return number;
};

export const CalculateExtraWage = (users, attendances) => {
  let totalMinutes = 0;
  attendances?.forEach((atten) => {
    const extraHour = atten?.extra_hour;
    if (extraHour) {
      const [hours, minutes] = extraHour.split(":");
      const hoursInMinutes = parseInt(hours, 10) * 60;
      totalMinutes += hoursInMinutes + parseInt(minutes, 10);
    }
  });
  const totalHours = totalMinutes / 60;
  const extraWage = parseFloat(users?.user_info?.extra_wage); // Ensure extra_wage is parsed as float
  const totalExtraWage =
    isNaN(totalHours) || isNaN(extraWage) ? 0 : totalHours * extraWage;

  return totalExtraWage;
};

export const TotalSumationWage = (users,attendances) => {
  const totalExtraWage = CalculateExtraWage(users,attendances);
  const totalDailyWage = TotalDailyWage(users,attendances);

  return parseFloat(totalExtraWage) + parseFloat(totalDailyWage);
};

export const formatTime = (datetime) => {
  const date = new Date(datetime);

  // console.log("date : ",datetime)
  if (datetime == null) {
    return `${0}h ${0}m`;
  }
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return `${hours}h ${minutes}m`;
};

export const calculateTimeDifference = (start, end) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const diffMs = endDate - startDate;
  if (isNaN(diffMs)) {
    return "Invalid date";
  }
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
  const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
  // console.log(`${diffHours}h ${diffMinutes}m`)
  return `${diffHours}h ${diffMinutes}m`;
};

export const calculateHourPerDay = (users,from,to) => {
  let startDate = new Date(from);
  let endDate = new Date(to);

  let diffrentTime = endDate.getTime() - startDate.getTime();
  diffrentTime = diffrentTime / (1000 * 3600 * 24);

  let firdayCount = 0;

  while (startDate <= endDate) {
    if (startDate.getDay() === 5) {
      firdayCount++;
    }
    // Move to the next day
    startDate.setDate(startDate.getDate() + 1);
  }
  console.log(diffrentTime);
  diffrentTime = diffrentTime - firdayCount;
  let hours = users?.user_info?.hour_per_day.split(":")[0];
  let minute = users?.user_info?.hour_per_day.split(":")[1];
  return `${hours * diffrentTime}h ${minute}m`;
};


export const montlyHourWorks = (users,attendances, from, to) => {
  let totalDifference = 0;
  let startDate = new Date(from);
  let endDate = new Date(to);
  let diffHour = endDate.getTime() - startDate.getTime();

  let firdayCount = 0;

  // Loop through each day between the two dates
  while (startDate <= endDate) {
    // Check if the current day is a Friday (5 is Friday in getDay())
    if (startDate.getDay() === 5) {
      firdayCount++;
    }
    // Move to the next day
    startDate.setDate(startDate.getDate() + 1);
  }

  diffHour = diffHour / (1000 * 3600 * 24) - firdayCount;

  users?.attendance?.forEach((atten) => {
    const startDate = new Date(atten?.approve_checkin);
    const endDate = new Date(atten?.approve_checkout);
    const diffMs = endDate - startDate;
    if (!isNaN(diffMs)) {
      totalDifference += diffMs;
    }
  });

  // Convert totalDifference to hours and minutes
  const totalHours = Math.floor(totalDifference / (1000 * 60 * 60));
  const totalMinutes = Math.floor((totalDifference / (1000 * 60)) % 60);

  // Calculate the expected hours and minutes for the month
  const hoursPerDay = users?.user_info?.hour_per_day.split(":")[0];
  const minutesPerDay = users?.user_info?.hour_per_day.split(":")[1];
  const totalMonthlyHours = hoursPerDay * 26;
  // const totalMonthlyMinutes = minutesPerDay ;

  // Calculate the difference
  let diffHours = totalMonthlyHours - totalHours;
  let diffMinutes = minutesPerDay - totalMinutes;
  // Adjust for negative minutes
  if (diffMinutes < 0) {
    diffHours -= 1;
    // diffMinutes += 60;
    diffMinutes *= -1;
  }

  // Log the results
  // console.log(`Difference: ${diffHours} hours and ${diffMinutes} minutes`);

  return `${diffHours}h ${diffMinutes}m`;

  // return { diffHours, diffMinutes };
};
